import React from "react"
import "./NotFound.scss"
import { Link } from "react-router-dom"
import BusinessIcon from "@tecuity/sos-icons/react/business"
import SearchIcon from '@tecuity/sos-icons/react/search-thin'
import FileBoxIcon from '@tecuity/sos-icons/react/file-box'

export default class NotFound extends React.Component {
  render() {
    return (
      <div className="not-found">
        <h1>404</h1>
        <span className="message">
          Oops, looks like the page you're looking for doesn't exist. You can
          try one of the links below or <Link to="/" replace>click here</Link> to return
          to the homepage.
        </span>
        <div className='quick-links'>
          <QuickLink icon={<BusinessIcon/>} title='Start a new business' href='/forms' />
          <QuickLink icon={<SearchIcon/>} title='Search for a record' href='/search' />
          <QuickLink icon={<FileBoxIcon/>} title='View my work queue' href='/queue' />
        </div>
      </div>
    )
  }
}

const QuickLink = ({icon, title, href}) => (
  <Link className='quick-link' to={href} replace>
    <div className='icon-wrapper'>
      {icon}
    </div>
    <span className='title'>
      {title}
    </span>
  </Link>
)



// WEBPACK FOOTER //
// ./src/components/NotFound/NotFound.js